<template>
  <div>
    <h2>Documentação do Ativo</h2>

    <v-data-table
      :headers="headers"
      :items="data"
      :page.sync="page"
      :sort-by.sync="sortBy"
      :items-per-page="perPage"
      :loading="isLoading"
      hide-default-footer
      disable-sort
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="searchFilter.query"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialogForm" max-width="940px">
            <template
              v-slot:activator="{ on, attrs }"
              v-if="permissions['create_registration']"
            >
              <v-btn
                outlined
                color="#0dc4b8"
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                Novo Documento
              </v-btn>
            </template>
            <RegistrationForm
              v-if="dialogForm"
              :selectedIndex="selectedIndex"
              :selectedData="selectedItem"
              :selectedActive="active"
              :filesRegistrationsProps="filesRegistrations"
              :filesAreasProps="filesAreas"
              v-on:onClose="closeFormModal"
              v-on:onSubmit="
                closeFormModal();
                loadData();
              "
            />
          </v-dialog>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline center"
                >Deseja realmente excluir {{ selectedItem.code }} -
                {{ selectedItem.description }} ?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#0dc4b8" text @click="closeDeleteModal"
                  >Cancelar</v-btn
                >
                <v-btn
                  color="#0dc4b8"
                  text
                  @click="deleteItemConfirm"
                  :disabled="
                    isLoading ||
                    ['Administrador', 'Cliente'].includes(selectedItem.name)
                  "
                  :loading="isLoading"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template
        v-slot:item.actions="{ item }"
        v-if="permissions['edit_registration']"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon :loading="isLoading">
              <v-icon
                dense
                @click="openEditItemModal(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template
            v-slot:activator="{ on, attrs }"
            v-if="permissions['delete_registration']"
          >
            <v-icon
              dense
              @click="openDeleteItemModal(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-delete
            </v-icon>
          </template>
          <span>Excluir</span>
        </v-tooltip>
      </template>

      <template v-slot:footer>
        <div class="table-footer">
          <span class="mr-4" v-if="total > 0"
            >Exibindo {{ from }} - {{ to }} de {{ total }}
          </span>
        </div>
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="totalPages"></v-pagination>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapMutations } from "vuex";
import RegistrationForm from "./_form.vue";
import Api from "../../services/api.service";

export default {
  name: "Registration",
  components: {
    RegistrationForm,
  },
  data: (route) => ({
    data: [],
    dialogForm: false,
    dialogDelete: false,
    dialogGenerate: false,
    isLoadingGenerate: true,
    from: 0,
    headers: [
      { text: "Código", value: "code" },
      { text: "Nome da documentação do Ativo", value: "name_registration" },
      { text: "Ativo", value: "name_token" },
      { text: "Lote", value: "lote" },
    ],
    isLoading: true,
    page: 1,
    perPage: 10,
    searchFilter: {
      query: null,
    },
    selectedIndex: -1,
    selectedItem: {},
    filesRegistrations: [],
    filesAreas: [],
    idEdit: 0,
    sortBy: "registration.code",
    to: 0,
    total: 0,
    totalPages: 0,
    value: 0,
    query: false,
    show: true,
    interval: 0,
    active: {},
    item: route,
  }),
  computed: {
    ...mapGetters(["permissions"]),
  },
  mounted() {
    if (
      this.permissions["edit_registration"] ||
      this.permissions["delete_registration"]
    ) {
      this.headers.push({ text: "Ações", value: "actions", sortable: false });
    }

    this.loadData();
  },
  methods: {
    ...mapMutations(["showSnackbar"]),

    clearForm() {
      this.selectedIndex = -1;
      this.selectedItem = {};
      this.isLoading = false;
    },

    closeFormModal() {
      this.isLoading = false;
      this.dialogForm = false;

      if (this.item) this.item = null;

      this.selectedIndex = -1;
      this.selectedItem = {};

      this.loadData();
      this.$nextTick(() => {
        this.clearForm();
      });
    },

    closeDeleteModal() {
      this.dialogDelete = false;
      this.isLoading = false;
      this.$nextTick(() => {
        this.clearForm();
      });
    },

    closeGenerateModal() {
      this.dialogGenerate = false;
      this.isLoading = false;
    },

    deleteItemConfirm() {
      this.isLoading = true;
      Api.delete(`registration/${this.selectedItem.code}`)
        .then(() => {
          this.loadData();
          this.showSnackbar({
            text: "Documentação deletada com sucesso!",
            color: "success",
          });
          this.closeDeleteModal();
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.showSnackbar({
            ext: "Ops! Ocorreu um erro, tente novamente.",
            color: "error",
          });
        });
    },

    loadData() {
      this.isLoading = true;

      var arrayActives = [];

      Api.get("registration")
        .then((res) => {
          res.data[0].map((item) => {
            arrayActives.push({
              code: item.id,
              name_registration: item.name_registration,
              lote: item.lote,
              active_id: item.active_id,
              name_token: item.name_token,
              token_initial_1: item.token_initial_1,
              token_final_1: item.token_final_1,
              token_initial_2: item.token_initial_2,
              token_final_2: item.token_final_2,
            });
          });

          this.data = arrayActives;

          this.isLoading = false;
        })
        .catch(() => {
          this.showSnackbar({
            text: "Ops! Houve um erro ao carregar os dados, tente novamente.",
            color: "error",
          });
          this.isLoading = false;
        })
        .then(() => {
          if (this.item.$route.params.activeId) {
            arrayActives = [];
            this.data.map((e) => {
              if (e.active_id == this.item.$route.params.activeId.code)
                arrayActives.push(e);
            });
          
            if (arrayActives.length > 0) {
              this.dialogForm = false;
              this.data = arrayActives;
            } else {
              this.dialogForm = true;
            }
          }
        })
    },

    openDeleteItemModal(item) {
      this.selectedIndex = this.data.indexOf(item);
      this.selectedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    openEditItemModal(item) {
      this.isLoading = true;

      Api.get(`registration/${item.code}`)
        .then((res) => {
          this.selectedItem = res.data.registration[0];
          this.active = res.data.active[0];
          this.selectedIndex = item.code;
          this.filesAreas = res.data.files_area;
          this.filesRegistrations = res.data.files_registration;

          this.isLoading = false;

          setTimeout(() => {
            this.dialogForm = true;
          }, 11);
        })
        .catch(() => {
          this.showSnackbar({
            text: "Ops! Houve um erro ao carregar os dados, tente novamente.",
            color: "error",
          });
          this.isLoading = false;
        });
    },
  },
};
</script>
